import React, { useEffect } from 'react';


// icon imports
import { FaArrowRight } from "react-icons/fa";


import AvalibleLink from "../element/AvalibleLink";
import ImageSlider from "../element/ImageSlider";


function Dialog({ projectData, onClose }) { 


  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);


  if (!projectData) return null;


  return (
    <div className="w-full h-screen fixed inset-0 bg-fj backdrop-blur-sm z-50 flex justify-center items-center">
      <div className="bg-fj w-full md:w-2/3 lg:w-3/5 max-h-[100vh] overflow-y-auto shadow-2xl rounded-lg">
        
        {/* Header with back button */}
        <div className="bg-fj sticky top-0  border-b border-gray-200 dark:border-gray-700 py-6 px-8 z-50">
          <button 
            onClick={onClose}
            className="flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            <FaArrowRight size={24} className="rotate-180" />
            <span className="font-medium text-xl px-2">{projectData.app_name}</span>
          </button>
        </div>

        {/* Content Section */}
        <div className="p-4 h-screen">

          {(Array.isArray(projectData.appScreenshots) && projectData.appScreenshots.length > 0) && (
            <div className="my-6">
              <ImageSlider images={projectData.appScreenshots} />
            </div>
          )}

          {/* Download Button */}
          <div className="flex justify-center mb-6">
            <AvalibleLink type={projectData.avalible_on} link={projectData.p_links} name={projectData.app_name} />
          </div>

          {/* Description */}
          <div className="text-white" dangerouslySetInnerHTML={{ __html: projectData.long_des.replace(/\n/g, '<br />') }} />
        </div>
      </div>
    </div>
  );
}

export default Dialog;
